<template>
  <jz-container v-on="this.$listeners" class="learning-history-log-list-item">
    <jz-container class="icon">
      <jz-icon :src="exerciseIcon" class="exercise-type-icon" />
    </jz-container>

    <jz-container class="type">
      <span class="label">
        {{ skillTitle | __ }}
      </span>

      <span class="content">
        {{ `exercise.type.${log.exerciseType}` | __ }}
      </span>
    </jz-container>

    <jz-container class="count">
      <span class="label">{{ "learning-history.practice-amount" | __ }}</span>

      <span class="content">{{ log.studyCount }}</span>
    </jz-container>

    <jz-container class="time">
      <span class="label">{{ "learning-history.practice-time" | __ }}</span>

      <span class="content">{{ studyTime }}</span>
    </jz-container>
  </jz-container>
</template>

<script>
import Vue from "vue";

import { getHoursAndMinutes, getSkillTitle, getExerciseIcon } from "@tt-app/utils";

export default Vue.extend({
  name: "LearningHistoryStatListItem",
  props: {
    log: { type: Object, required: true }
  },
  computed: {
    studyTime() {
      const time = this.log.studyTime;
      const { hours, minutes } = getHoursAndMinutes(time);
      const hourString = hours ? this.$__("common.hours", hours) : "";
      const minuteString = this.$__("common.minutes", minutes);
      return `${hourString}${minuteString}`;
    },
    skillTitle() {
      return getSkillTitle(this.log.exerciseType, this.log.skill);
    },
    exerciseIcon() {
      return getExerciseIcon(this.log.exerciseType, this.log.skill);
    }
  }
});
</script>

<style lang="scss">
.learning-history-log-list-item {
  align-items: center;
  cursor: pointer;
  display: grid;
  padding: ($gutter * 0.75) $gutter;
  grid-template-columns: 48px auto 130px;
  grid-template-rows: auto auto;
  grid-template-areas:
    "icon type type"
    "icon count time";

  & + .learning-history-log-list-item {
    border-top: 1px solid rgba(var(--rgb-black), 0.08);
  }

  .icon {
    grid-area: icon;
    height: $icon-size-lg;
    width: $icon-size-lg;

    img {
      height: $icon-size-lg;
      width: $icon-size-lg;
    }
  }

  .type {
    grid-area: type;

    .label {
      background-color: var(--color-primary-alternate-background-light);
      border-radius: 4px;
      font-size: $font-size-xxs;
      font-weight: bold;
      margin: 0 ($gutter / 4) 0 0;
      /* The font used seems to have a lot of spacing on the right
       * so adding right padding makes the text look off center
       */
      padding: ($gutter / 4) 0 ($gutter / 4) ($gutter / 4);
    }

    .content {
      grid-column: 2;
      grid-row: 2;
    }
  }

  .count {
    grid-area: count;
  }

  .time {
    grid-area: time;
  }

  .label {
    color: var(--color-secondary);
    font-size: $font-size-xs;
    margin: 0 ($gutter / 2) 0 0;
  }

  .content {
    color: var(--color-dark);
    font-size: $font-size-sm;
    font-weight: bold;
  }
}

@include responsive(tablet) {
  .learning-history-log-list-item {
    grid-template-columns: 48px auto 103px 130px;
    grid-template-rows: auto;
    grid-template-areas: "icon type count time";
  }
}
</style>
